common.View.create('shop::Habitats.Website.Modules.ShopCheckout.Order.ShippingMethod', {

    ajaxCalls: [],

    onDOMLoad() {
        this.initDeliveryMethodPrice();
    },

    initDeliveryMethodPrice()
    {
        this.element
            .find('.line-one input[name="shipping_method"]')
                .change((event) => {
                    // Abort ajax calls
                    this.abortAjaxCalls();

                    // Remove value from PostNL locations
                    this.element.find('.line-two select').val('');

                    // On delivery method change
                    this.initDeliveryMethodPriceChange( this.element.find('.nice-radio-buttons input[type="radio"]:checked').val() );
                })
                .end()
            .find('.nice-radio-buttons input[type="radio"]')
                .change((event) => {
                    // Abort ajax calls
                    this.abortAjaxCalls();

                    // Remove value from PostNL locations
                    this.element.find('.line-two select').val('');

                    // On delivery method change
                    this.initDeliveryMethodPriceChange( $(event.currentTarget).val() );
                })
                .end()
            .find('.line-two')
                .find('input, select')
                    .on('change', (event) => {
                        // Remove checked from delivery method 'deliver'
                        this.element.find('.nice-radio-buttons input[type="radio"]').prop('checked', false);

                        // On delivery method retrieve change
                        this.initDeliveryMethodRetrieve( this.element.find('.line-two select').val() );
                    })
                    .end()
                .end()
            .find('.line-normal input')
                .on('change', (event) => {
                    // Remove checked from delivery method 'deliver'
                    this.element.find('.nice-radio-buttons input[type="radio"]').prop('checked', false);

                    // Remove value from PostNL locations
                    this.element.find('.line-two select').val('');

                    this.initDeliveryMethodRetrieveStore( $(event.currentTarget).val() );
                })
                .end();

    },

    async abortAjaxCalls()
    {
        // There are ajax calls running?
        if( this.ajaxCalls ) {
            // Abort all calls
            for(let i = 0; i < this.ajaxCalls.length; i++) {
                this.ajaxCalls[i].abort();
            }
        }
    },

    async initDeliveryMethodPriceChange(value)
    {
        // Post
        let ajaxCallPromise = $.post(this.element.data('url') + '/shipping-information', {
            deliveryDate: value,
            order: $('.shop\\:\\:Habitats-Website-Modules-ShopCheckout-Order-Index').find('form.order').serialize()
        });

        await this.initDeliveryMethodBasic(ajaxCallPromise);
    },

    async initDeliveryMethodRetrieve(value)
    {
        // Post
        let ajaxCallPromise = $.post(this.element.data('url') + '/shipping-information', {
            deliveryMethodRetrieve: value,
        });

        await this.initDeliveryMethodBasic(ajaxCallPromise);
    },

    async initDeliveryMethodRetrieveStore(value)
    {
        // Post
        let ajaxCallPromise = $.post(this.element.data('url') + '/shipping-information', {
            deliveryMethod: value,
        });

        await this.initDeliveryMethodBasic(ajaxCallPromise);
    },

    async initDeliveryMethodBasic(ajaxCallPromise)
    {
        // Push to ajax calls
        this.ajaxCalls.push(ajaxCallPromise);

        // Wait for ajax call to finish
        await ajaxCallPromise;

        // Reload totals
        shop.Habitats.Website.Modules.ShopCheckout.Order.Index.getInstance(this).reloadTotals();
        shop.Habitats.Website.Modules.ShopCheckout.Order.Index.getInstance(this).reloadSigned();
    }

});
